<template>
  <BaseModal
    small
    :heading="$t('register.salonized_pay.dashboard.schedule.heading')"
    testId="sp-payout-schedule"
    @close="$emit('close')"
  >
    <BaseTable
      :headers="[
        $t('register.salonized_pay.dashboard.schedule.day_of_sale'),
        $t('register.salonized_pay.dashboard.schedule.payout_day')
      ]"
      :rows="[
        { cells: [$t('global.days.mo'), $t('global.days.we')] },
        { cells: [$t('global.days.tu'), $t('global.days.th')] },
        { cells: [$t('global.days.we'), $t('global.days.fr')] },
        { cells: [$t('global.days.th'), $t('global.days.mo')] },
        {
          cells: [
            $t('global.days.fr'),
            $t('register.salonized_pay.dashboard.schedule.next_tuesday')
          ]
        },
        {
          cells: [
            $t('global.days.sa'),
            $t('register.salonized_pay.dashboard.schedule.next_tuesday')
          ]
        },
        {
          cells: [
            $t('global.days.su'),
            $t('register.salonized_pay.dashboard.schedule.next_tuesday')
          ]
        }
      ]"
    />
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
defineEmits(['close']);
</script>
